export const FASTEST_UPDATE_RATE = 100;
export const FAST_UPDATE_RATE = 180;
export const MID_UPDATE_RATE = 350;
export const SLOW_UPDATE_RATE = 1000;
export const SLOWEST_UPDATE_RATE = 10000;
